import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations

// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule, MatSpinner, MatProgressSpinnerModule, MatProgressBarModule, MatDialogModule, MatExpansionModule, MatFormFieldModule,
    MatInputModule, MatSlideToggleModule, MatHint, MatSortModule, MatRadioModule, MatSelectModule, MatCheckboxModule,
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

import {UserProfileComponent} from './UserProfileComponent/user-profile.component';
import {UsersListComponent} from './UsersListComponent/users-list.component';
import {UserService} from '../services/user.service';
import {UserDeleteConfirmDialogComponent} from './UserDeleteConfirmDialogComponent/user-delete-confirm.dialog.component';
import {UserDetailComponent} from './UserDetailComponent/user-detail.component';
import {RouterModule} from '@angular/router';
import {UserEditComponent} from './UserEditComponent/user-edit.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {EditorModule} from '@tinymce/tinymce-angular';
import {DirectivesModule} from '../directives/directives.module';
import {RoleService} from '../services/role.service';
// import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@NgModule({
    declarations: [
        UsersListComponent,
        UserProfileComponent,
        UserDetailComponent,
        UserEditComponent,
        UserDeleteConfirmDialogComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule,
        DirectivesModule,

        // Angular Material animations
        // BrowserAnimationsModule,

        // Angular Material components
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        MatTableModule,
        MatToolbarModule,
        MatTooltipModule,

        PipesModule,
    ],
    exports: [
        UserProfileComponent
    ],
    entryComponents: [
        UserDeleteConfirmDialogComponent
    ],
    providers: [
        UserService,
        RoleService,
    ]
})
export class UsersModule {
}



// WEBPACK FOOTER //
// /app/src/UsersModule/users.module.ts